var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
import { IsBoolean, IsDate, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { ConsentDateSearchInput, ConsentStatus, ConsentType } from "./consent.dtos";
import { BaseStudySearchInput, StudyDto } from "./study.dtos";
import { USAStates } from "./usaStates";
export class ConsentRequestDto {
}
__decorate([
    IsString()
], ConsentRequestDto.prototype, "id", void 0);
__decorate([
    IsString()
], ConsentRequestDto.prototype, "identifiedPatientId", void 0);
__decorate([
    IsString(),
    IsOptional()
], ConsentRequestDto.prototype, "patientId", void 0);
__decorate([
    ValidateNested(),
    Type(() => StudyDto)
], ConsentRequestDto.prototype, "study", void 0);
__decorate([
    IsEnum(ConsentType)
], ConsentRequestDto.prototype, "consentType", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], ConsentRequestDto.prototype, "timestamp", void 0);
__decorate([
    IsBoolean()
], ConsentRequestDto.prototype, "pending", void 0);
export class ConsentRequestSearchInput {
}
__decorate([
    ValidateNested(),
    Type(() => BaseStudySearchInput),
    IsOptional()
], ConsentRequestSearchInput.prototype, "study", void 0);
__decorate([
    IsString(),
    IsOptional()
], ConsentRequestSearchInput.prototype, "studyId", void 0);
__decorate([
    IsEnum(ConsentType, { each: true }),
    IsOptional()
], ConsentRequestSearchInput.prototype, "consentType", void 0);
__decorate([
    IsString(),
    IsOptional()
], ConsentRequestSearchInput.prototype, "identifiedPatientId", void 0);
__decorate([
    IsString(),
    IsOptional()
], ConsentRequestSearchInput.prototype, "patientId", void 0);
__decorate([
    IsEnum(USAStates),
    IsOptional()
], ConsentRequestSearchInput.prototype, "patientState", void 0);
__decorate([
    ValidateNested(),
    Type(() => ConsentDateSearchInput),
    IsOptional()
], ConsentRequestSearchInput.prototype, "timestamp", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], ConsentRequestSearchInput.prototype, "pending", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], ConsentRequestSearchInput.prototype, "distinctPending", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], ConsentRequestSearchInput.prototype, "includeConsentingByLink", void 0);
__decorate([
    IsEnum(ConsentStatus, { each: true }),
    IsOptional()
], ConsentRequestSearchInput.prototype, "includePatientStudyConsentStatuses", void 0);
export class ConsentRequestSearchResult {
}
__decorate([
    IsNumber()
], ConsentRequestSearchResult.prototype, "total", void 0);
__decorate([
    IsNumber()
], ConsentRequestSearchResult.prototype, "totalStudies", void 0);
__decorate([
    Type(() => ConsentRequestDto),
    ValidateNested({ each: true })
], ConsentRequestSearchResult.prototype, "results", void 0);
